import { DateTime } from 'luxon';

const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

const parseFriendlyDate = (isoDate: string, capitalize?: boolean, time?: boolean) => {
  const date = DateTime.fromISO(isoDate).setLocale('es');
  const dayOfWeek = date.toFormat('cccc'); // Obtiene el día de la semana con la primera letra en mayúscula
  const { day } = date; // Obtiene el día del mes sin ceros a la izquierda
  const month = date.toFormat('LLLL'); // Obtiene el nombre completo del mes
  const hour = date.toFormat('HH:mm'); // Obtiene la hora

  if (time) {
    return `${capitalize ? capitalizeFirstLetter(dayOfWeek) : dayOfWeek} ${day} de ${month} - ${hour}hs`;
  }

  return `${capitalize ? capitalizeFirstLetter(dayOfWeek) : dayOfWeek} ${day} de ${month}`;
};

const parseFriendlyDateAndHour = (isoDate: string, withHour?: boolean, withYear?: boolean, useLocalTimezone?: boolean) => {
  if (useLocalTimezone) {
    const date = DateTime.fromISO(isoDate, { zone: 'utc' });
    if (withHour && withYear) {
      return date.setLocale('es').toFormat('dd/MM/yyyy - HH:mm');
    }
    if (withYear) {
      return date.setLocale('es').toFormat('dd/MM/yyyy');
    }
    if (withHour) {
      return date.setLocale('es').toFormat('dd/MM/yyyy - HH:mm');
    }
    return date.setLocale('es').toFormat('dd/MM/yyyy');
  }

  if (withHour && withYear) {
    return DateTime.fromISO(isoDate).setLocale('es').toFormat('dd/MM/yy - HH:mm');
  }
  if (withYear) {
    return DateTime.fromISO(isoDate).setLocale('es').toFormat('dd/MM/yy');
  }
  if (withHour) {
    return DateTime.fromISO(isoDate).setLocale('es').toFormat('dd/MM - HH:mm');
  }
  return DateTime.fromISO(isoDate).setLocale('es').toFormat('dd/MM');
};

const formatDateYYYYMMDD = (date: string | Date) => {
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

const formatDateForInput = (dateString: string | null) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  const offset = date.getTimezoneOffset();
  const adjustedDate = new Date(date.getTime() - (offset * 60 * 1000));
  return adjustedDate.toISOString().slice(0, 16);
};

const combineDateAndTime = (date: string, time: string) => {
  const [year, month, day] = date.split('-');
  const [hours, minutes] = time.split(':');
  const combinedDate = new Date(
    parseInt(year, 10),
    parseInt(month, 10) - 1,
    parseInt(day, 10),
    parseInt(hours, 10),
    parseInt(minutes, 10),
  );
  return combinedDate.toISOString();
};

const formatDateForTable = (isoDate: string) => {
  if (!isoDate) {
    return '';
  }
  return DateTime.fromISO(isoDate).setLocale('es').toFormat('dd/MM/yyyy - HH:mm');
};

export {
  parseFriendlyDate, parseFriendlyDateAndHour, formatDateYYYYMMDD, formatDateForInput, combineDateAndTime, formatDateForTable,
};
